module.exports = __webpack_public_path__ + "img/BH.0e8b8b47.png";